import { intersection } from 'lodash';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { HANDLE_IN_BUDDHIMED_MODAL } from '../constants/crmConstants';

export const useCallBuddhimed = (formConfig: any): any => {
  const { claimDetails } = useSelector((state: RootState): any => state.admissionDetails);
  const { selectedBeneficiaryDetail } = useSelector((state: RootState): any => state.newAdmission);
  const isBuddhimedRequired = formConfig?.some((config: any): any => Boolean(config?.buddhimedForAllFlows));
  const shouldCall = (): boolean => {
    if ((claimDetails && Object.keys(claimDetails)) || selectedBeneficiaryDetail) {
      const { nextAllowStatus } = claimDetails;
      return (!intersection(HANDLE_IN_BUDDHIMED_MODAL, nextAllowStatus).length || isBuddhimedRequired);
    }
    return false;
  };

  return { shouldCall };
};
